import React from 'react';
import PropTypes from 'prop-types';

function AddButton({ upload }) {
  return (
    <>
      <label
        className="btn btn-primary btn-large new-btn-space"
        htmlFor="fontUpload"
      >
        Add Font
      </label>
      <input
        type="file"
        accept=".ttf"
        id="fontUpload"
        onChange={e =>
          e?.target?.files?.length
            ? upload.action({
                file: e.target.files[0],
                onError: upload.onError,
                onSuccess: upload.onSuccess,
              })
            : null
        }
      />
    </>
  );
}

AddButton.propTypes = {
  upload: PropTypes.any,
};

export default AddButton;
